import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { BuildingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const Guest_House_Notice = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  {/* <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("GUEST HOUSE CLOSURE NOTICE")}</h3>
                  </div> */}
                  <div className="col-lg-12 about-head1">
                    <div className="guest-notice">
                        <div className="notic-head1">
                            <h3>GUEST HOUSE CLOSURE NOTICE</h3>
                        </div>
                        <div className="mayor-tabl">
                          <table class="table table-bordered tb1 table-striped table-hover">
                             <thead class="table-bor-3">
                              <tr>
                                <th> Borough No. </th>
                                <th> Closure Notice </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td> BR-1 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-2 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-3 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-4 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-5 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-6 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-7 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-8 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-9 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-10 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-6 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-11 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-12 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-13 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-14 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-15 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>
                              <tr>
                                <td> BR-16 GUEST HOUSE CLOSURE NOTICE </td>
                                <td className="down">
                                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${" "}&tenantId=km.kolkata`}> Download </a>
                                </td>
                              </tr>

                              

                            </tbody>
                          </table>
                        </div>
  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Guest_House_Notice;
